/*
 * TOPIAM Employee - Employee Identity and Access Management
 * Copyright © 2022-Present Jinan Yuanchuang Network Technology Co., Ltd. (support@topiam.cn)
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
export default {
  'pages.app.create.desc.0':
    '本页面包含了所有已支持的可添加应用列表，管理员可以选择需要使用的应用进行初始化配置，并开始后续使用。',
  'pages.app.create.desc.1':
    '应用分为两种：一种是支持标准的 OIDC、JWT、表单代填 等模板的应用，在这里可以通过添加对应的标准应用模板来实现单点登录功能。',
  'pages.app.create.form_text.name': '模版名称',
  'pages.app.create.header_title': '标准协议',
  'pages.app.create.modal_form.title': '添加应用',
  'pages.app.create.modal_form.name': '应用名称',
  'pages.app.create.modal_form.group': '应用分组',
  'pages.app.create.modal_form.name.placeholder': '请输入应用名称',
  'pages.app.create.modal_form.name.message': '应用名称为必填项',
  'pages.app.create.modal_form.name.rule.0': '应用名称为必填项',
  'pages.app.create.modal_form.remark': '备注',
  'pages.app.create.modal_form.remark.placeholder': '请输入备注信息',
  'pages.app.create.modal_form.modal_success.content': '请进入应用管理页面完善配置并查看信息',
  'pages.app.create.modal_form.modal_success.ok_text': '完善配置',
};
